<template>
  <div class="register-container">
    <div class="register-form">
      <div class="register-header">
        <div class="logo">
          <i class="fas fa-user-plus"></i>
        </div>
        <h1>用户注册</h1>
        <p class="subtitle">创建您的AI聊天账户</p>
      </div>
      
      <form @submit.prevent="handleRegister" class="register-form-content">
        <div class="form-group">
          <div class="input-icon">
            <i class="fas fa-user"></i>
          </div>
          <input
            type="text"
            v-model="registerForm.loginAccount"
            placeholder="请输入登录账户（3-20个字符）"
            required
            class="form-input"
          />
        </div>
        
        <div class="form-group">
          <div class="input-icon">
            <i class="fas fa-user-circle"></i>
          </div>
          <input
            type="text"
            v-model="registerForm.displayName"
            placeholder="请输入用户名（2-20个字符）"
            required
            class="form-input"
          />
        </div>
        
        <div class="form-group">
          <div class="input-icon">
            <i class="fas fa-lock"></i>
          </div>
          <input
            :type="showPassword ? 'text' : 'password'"
            v-model="registerForm.password"
            placeholder="请输入密码（至少6位）"
            required
            class="form-input password-input-main"
            @input="checkPasswordStrength"
          />
          <div class="password-toggle" @click="togglePassword">
            <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </div>
        </div>
        
        <!-- 密码复杂度提示 - 移到form-group外部 -->
        <div class="password-strength" v-if="registerForm.password">
          <div class="strength-bar">
            <div class="strength-fill" :class="passwordStrengthClass"></div>
          </div>
          <div class="strength-text">{{ passwordStrengthText }}</div>
          <div class="complexity-requirements">
            <div class="requirement" :class="{ met: registerForm.password.length >= 6 }">
              <i :class="registerForm.password.length >= 6 ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
              至少6位
            </div>
          </div>
        </div>
        
        <div class="form-group">
          <div class="input-icon">
            <i class="fas fa-lock"></i>
          </div>
          <input
            :type="showConfirmPassword ? 'text' : 'password'"
            v-model="registerForm.confirmPassword"
            placeholder="请确认密码"
            required
            class="form-input password-input-confirm"
          />
          <div class="password-toggle" @click="toggleConfirmPassword">
            <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </div>
        </div>
        
        <div class="form-group">
          <div class="input-icon">
            <i class="fas fa-mobile-alt"></i>
          </div>
          <input
            type="tel"
            v-model="registerForm.phone"
            placeholder="请输入手机号"
            required
            class="form-input"
          />
        </div>
        
                 <!-- 移除验证码输入框 -->
        
        <button type="submit" class="register-button" :disabled="loading">
          {{ loading ? '注册中...' : '立即注册' }}
        </button>
        
        <div class="login-link">
          已有账户？<a href="#" @click.prevent="goToLogin">立即登录</a>
        </div>
      </form>
      
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
      
      <div v-if="successMessage" class="success-message">
        {{ successMessage }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Register',
  data() {
    return {
             registerForm: {
         loginAccount: '',
         displayName: '',
         password: '',
         confirmPassword: '',
         phone: ''
       },
       showPassword: false,
       showConfirmPassword: false,
       loading: false,
       errorMessage: '',
       successMessage: '',
       passwordStrengthClass: 'weak',
       passwordStrengthText: '密码强度：弱'
    }
  },
     mounted() {
     // 页面加载时的初始化逻辑
   },
  methods: {
    async handleRegister() {
      this.loading = true;
      this.errorMessage = '';
      this.successMessage = '';
      
             try {
         const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/auth/register`, {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json'
           },
           body: JSON.stringify(this.registerForm)
         });
        
        const data = await response.json();
        
        if (data.success) {
          this.successMessage = data.message;
                     // 清空表单
           this.registerForm = {
             loginAccount: '',
             displayName: '',
             password: '',
             confirmPassword: '',
             phone: ''
           };
          // 3秒后跳转到登录页
          setTimeout(() => {
            if (this.$route.path !== '/login') {
              this.$router.push('/login');
            }
          }, 3000);
        } else {
          this.errorMessage = data.message || '注册失败';
        }
      } catch (error) {
        this.errorMessage = '网络错误，请检查连接';
        console.error('Register error:', error);
      } finally {
        this.loading = false;
      }
    },
    
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    
         // 移除验证码相关方法
    
    goToLogin() {
      // 检查当前路由，避免重复导航
      if (this.$route.path !== '/login') {
        this.$router.push('/login');
      }
    },
    
    checkPasswordStrength() {
      const password = this.registerForm.password;
      
      // 检查密码长度
      const hasLength = password.length >= 6;
      
      // 计算密码强度
      let strength = 0;
      if (hasLength) strength++;
      
      // 如果密码长度足够，根据长度和复杂度进一步评估
      if (hasLength) {
        if (password.length >= 8) {
          strength += 2; // 8位以上加分
        } else if (password.length >= 6) {
          strength += 1; // 6-7位
        }
        
        // 检查是否包含数字和字母
        if (/\d/.test(password) && /[a-zA-Z]/.test(password)) {
          strength += 1; // 包含数字和字母加分
        }
      }
      
      // 设置密码强度样式和文本
      if (strength >= 3) {
        this.passwordStrengthClass = 'strong';
        this.passwordStrengthText = '密码强度：强';
      } else if (strength >= 2) {
        this.passwordStrengthClass = 'medium';
        this.passwordStrengthText = '密码强度：中';
      } else {
        this.passwordStrengthClass = 'weak';
        this.passwordStrengthText = '密码强度：弱';
      }
    }
  }
}
</script>

<style scoped>
.register-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
  position: relative;
    background-image: url('@/assets/imgs/bg.jpg');
  background-repeat: no-repeat;
}

.register-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(222, 134, 90);
  opacity: 0.4;
  backdrop-filter: blur(100px);
}

.register-form {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  width: 400px;
  max-width: 90vw;
  position: relative;
  z-index: 1;
}

.register-header {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  width: 60px;
  height: 60px;
  background: #c03333;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
}

.logo i {
  color: white;
  font-size: 24px;
}

.register-header h1 {
  color: #2c3e50;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.subtitle {
  color: #7f8c8d;
  font-size: 14px;
  margin: 0;
}

.form-group {
  position: relative;
  margin-bottom: 20px;
}

/* 确保密码输入框组有足够的底部间距 */
.form-group .password-input-main,
.form-group .password-input-confirm {
  margin-bottom: 0;
}

.input-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #95a5a6;
  z-index: 2;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
  pointer-events: none;
  user-select: none;
  background: transparent;
}

.form-input {
  width: 100%;
  padding: 15px 15px 15px 45px;
  border: 2px solid #ecf0f1;
  border-radius: 10px;
  font-size: 16px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  line-height: 1.5;
  height: 50px;
}

/* 为密码输入框添加右侧padding，避免文字与眼睛图标重叠 */
.password-input-main,
.password-input-confirm {
  padding-right: 50px;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.password-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #95a5a6;
  cursor: pointer;
  z-index: 3;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;
  font-size: 16px;
  line-height: 1;
  user-select: none;
  background: transparent;
  pointer-events: auto;
  overflow: hidden;
}

.password-toggle:hover {
  color: #667eea;
}

/* 确保图标在输入框聚焦时也能正确显示 */
.form-input:focus + .password-toggle {
  color: #667eea;
}

/* 优化图标对齐 */
.input-icon i,
.password-toggle i {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 确保眼睛图标不会重复显示 */
.password-toggle i {
  position: relative;
  z-index: 1;
}

/* 移除验证码相关样式 */

.register-button {
  width: 100%;
  background: #c03333;
  color: white;
  border: none;
  padding: 15px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.register-button:hover:not(:disabled) {
  background: #ff3742;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(255, 71, 87, 0.3);
}

.register-button:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.login-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #7f8c8d;
}

.login-link a {
  color: #c03333;
  text-decoration: none;
  font-weight: 600;
}

.login-link a:hover {
  text-decoration: underline;
}

.error-message {
  color: #e74c3c;
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
  background: rgba(231, 76, 60, 0.1);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid rgba(231, 76, 60, 0.2);
}

.success-message {
  color: #27ae60;
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
  background: rgba(39, 174, 96, 0.1);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid rgba(39, 174, 96, 0.2);
}

/* 密码强度样式 */
.password-strength {
  margin-top: 15px;
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  position: relative;
  z-index: 1;
}

.strength-bar {
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 8px;
}

.strength-fill {
  height: 100%;
  transition: all 0.3s ease;
  border-radius: 3px;
}

.strength-fill.weak {
  width: 25%;
  background: #dc3545;
}

.strength-fill.medium {
  width: 50%;
  background: #ffc107;
}

.strength-fill.strong {
  width: 100%;
  background: #28a745;
}

.strength-text {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 10px;
  text-align: center;
  font-weight: 500;
}

.complexity-requirements {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.requirement {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #6c757d;
  transition: color 0.3s ease;
  font-weight: 500;
}

.requirement.met {
  color: #28a745;
}

.requirement i {
  margin-right: 6px;
  font-size: 12px;
}

.requirement.met i {
  color: #28a745;
}

.requirement:not(.met) i {
  color: #dc3545;
}

@media (max-width: 480px) {
  .register-form {
    padding: 30px 20px;
    width: 100%;
    margin: 20px;
  }
  
  .form-input {
    height: 45px;
    font-size: 14px;
  }
  
  .input-icon,
  .password-toggle {
    font-size: 14px;
  }
  
  /* 移除验证码相关响应式样式 */
}
</style>
